var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5070_27089)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    transform: "translate(0 0.957031)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45142 18.9027C8.69749 18.6566 9.07721 18.6253 9.35669 18.8099L9.469 18.9027L24.6692 34.1019L34.6321 24.1409L34.7454 24.0482C35.0248 23.8639 35.4047 23.895 35.6506 24.1409L54.3176 42.806L54.3167 31.9818C54.3169 31.5845 54.6391 31.2624 55.0364 31.262C55.4337 31.2621 55.7558 31.5844 55.7561 31.9818L55.759 44.5482C55.759 44.5532 55.7572 44.5587 55.7571 44.5638C55.7562 44.5986 55.7532 44.6329 55.7473 44.6673C55.7453 44.6794 55.7431 44.6914 55.7405 44.7034C55.7333 44.7353 55.7237 44.7664 55.7122 44.7972C55.7083 44.8075 55.7057 44.8183 55.7014 44.8284C55.6894 44.8566 55.6733 44.8827 55.6575 44.9095C55.6266 44.9623 55.592 45.013 55.5481 45.057C55.4469 45.1582 55.3182 45.2265 55.1799 45.2542L55.1292 45.2581C55.1148 45.2599 55.1006 45.2621 55.0862 45.263L55.0383 45.2679H42.47C42.0726 45.2676 41.7503 44.9456 41.7502 44.5482C41.7505 44.1509 42.0727 43.8287 42.47 43.8284H53.3049L35.1409 25.6673L25.179 35.6302C24.8978 35.9111 24.4415 35.9111 24.1604 35.6302L8.45142 19.9202L8.35864 19.8079C8.17406 19.5285 8.2055 19.1487 8.45142 18.9027Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5070_27089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.957031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.95382311ce29a19010971fe193360126.svg";
export { ForwardRef as ReactComponent };